import $ from 'jquery';
//import { MediaQuery } from 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import { SetVideoSrc, LoadVideo, PauseVideo } from './video';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';


gsap.registerPlugin(ScrollTrigger);

const $videoSnippetItemsSources = $('.video-snippet .the-video source');

const lazyLoadVideos = function ($thisVideoSnippetItemSource, $thisVideoSnippetItem) {
	let dataSource = $thisVideoSnippetItemSource.attr('data-lazy-src');

	SetVideoSrc($thisVideoSnippetItemSource, dataSource);
	LoadVideo($thisVideoSnippetItem);

	// if (MediaQuery.is('medium')) {
	// 	PlayVideo($thisVideoSnippetItem);
	// } else {
	// 	PauseVideo($thisVideoSnippetItem);
	// }
};

export const LazyPlay = function () {

	//console.log('firing');

	$videoSnippetItemsSources.each(function () {
		let $thisVideoSnippetItemSource = $(this),
			$thisVideoSnippetItem = $thisVideoSnippetItemSource.parent('video');

		ScrollTrigger.matchMedia({
			'(min-width: 40em)': function () {
				ScrollTrigger.create({
					trigger: $thisVideoSnippetItem,
					onEnter: () => lazyLoadVideos($thisVideoSnippetItemSource, $thisVideoSnippetItem),
					onLeave: () => PauseVideo($thisVideoSnippetItem),
					onEnterBack: () => lazyLoadVideos($thisVideoSnippetItemSource, $thisVideoSnippetItem),
					onLeaveBack: () => PauseVideo($thisVideoSnippetItem),
				});
			},
			'(max-width: 40em)': function () {
				ScrollTrigger.create({
					trigger: $thisVideoSnippetItem,
					onEnter: () => lazyLoadVideos($thisVideoSnippetItemSource, $thisVideoSnippetItem),
				});
			},
		});
	});
};
